export default __webpack_public_path__ + "static/media/azure.4993a0d8.svg";